export const REFERENCE_NUMBER = 'referenceNumber' as const
